const maxWidth = {
    xxs: "500px",
    xs: "768px",
    s:"820px",
    m:"912px",
    lg: "1250"
}

export {maxWidth}